defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
  [
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/Authentification/Scripts/LoginController'
  ],
  function (Utils, LoginController) {

    // Technically Utils.js should not hold any state. However I agreed with Micki that we'll do this, to
    // prevent the subscribeUserLoggedOut function to be called multiple times from each page,
    // so we don't DOS ourselves
    this.hasSubscribedToLogout = false;

    var redirectOnLogout = function (url) {
      if (this.hasSubscribedToLogout) {
        return;
      }

      if (!url) {
        url = window.location.origin;
      }

      window.DSAPI && DSAPI.ready(function () {
        DSAPI.Account.subscribeUserLoggedOut({
          callback: function () {
            window.location.href = url;
          }.bind(this)
        });
      }.bind(this));

      this.hasSubscribedToLogout = true;
    }.bind(this);

    var triggerBalanceUpdate = function () {
      window.DSAPI && DSAPI.ready(function () {
        DSAPI.Account.doBalanceUpdate();
      });
    };

    var shortenPlayerName = function (name, type) {
      type = type || 'compact';
      var nameParts = name.split(' ');
      var returnValue = '';

      // Anders Pedersen -> AP
      if (type === 'compact') {
        nameParts.forEach(function (part) {
          returnValue += part.substring(0, 1);
        });

        returnValue = returnValue.toUpperCase();
      }

      // Anders Pedersen -> Anders P.
      if (type === 'short') {
        returnValue = nameParts[0].toUpperCase() + ' ';

        nameParts.splice(0, 1);
        nameParts.forEach(function (part) {
          returnValue += part.substring(0, 1).toUpperCase();
        });

        returnValue += '.';
      }

      return returnValue;
    };

    /**
     * Get week number from a date.
     * Function converts a locale date object to a UTC date, then calculates a week number based on the start of the year
     * This function takes Weeek 53 into account as well (happens roughly every 6 years)
     * "Inspiration" from: https://stackoverflow.com/a/6117889
     */
    var getWeekNumber = function (date) {
      if (isNaN(Date.parse(date))) {
        console.error('Not a valid date format', date);
        return;
      }

      date = new Date(date);

      var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      var dayNum = utcDate.getUTCDay() || 7;
      utcDate.setUTCDate(utcDate.getUTCDate() + 4 - dayNum);
      var yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
      var weekNumber = Math.ceil((((utcDate - yearStart) / 86400000) + 1) / 7);

      return weekNumber;
    };

    var formatDrawWeeks = function (play) {
      if (!play) return '';

      var firstDrawWeek = getWeekNumber(play.firstDraw);

      var drawWeeks = firstDrawWeek;
      var lastDrawWeek;

      if (play.numberOfDraws === 1) {
        return drawWeeks;
      }

      if (play.draws && play.draws.length > 1) {
        lastDrawWeek = getWeekNumber(play.draws[play.draws.length - 1].drawDate);
        if (firstDrawWeek !== lastDrawWeek) {
          drawWeeks = firstDrawWeek + ' - ' + lastDrawWeek;
        }
        return drawWeeks;
      }

      lastDrawWeek = firstDrawWeek + (play.numberOfDraws - 1); // Withdraw 1, because first week should not be counted

      if (lastDrawWeek >= 52) {
        lastDrawWeek = lastDrawWeek - firstDrawWeek;
      }

      drawWeeks = firstDrawWeek + ' - ' + lastDrawWeek;

      return drawWeeks;
    };

    var countTotalRows = function (play) {
      if (!play) return null;

      return play.playerFundingSummaries.reduce(function (rowCount, funding) {
        return rowCount + funding.rowCount;
      }, 0);
    };

    var gameTypeMapping = function (gameType) {
      var mapping = {
        saturday: 'LottoSaturday',
        wednesday: 'VikingLotto',
        eurojackpot: 'EuroJackpot'
      };

      if (mapping[gameType]) {
        return mapping[gameType];
      }

      return gameType;
    };

    var mapGameToDictionary = function (gameType) {
      gameType = gameType.toLowerCase();

      var mapping = {
        lottosaturday: 'Lotto',
        lotto: 'Lotto',
        vikinglotto: 'VikingLotto',
        eurojackpot: 'Eurojackpot'
      };

      if (mapping[gameType]) {
        return mapping[gameType];
      }

      return gameType;
    };

    var mapGameIcon = function (game) {
      game = game?.toLowerCase();

      var mapping = {
        eurojackpot: 'icon-eurojackpot_logo_bg_yellow',
        lotto: 'icon-lotto_logo_red',
        lottosaturday: 'icon-lotto_logo_red',
        vikinglotto: 'icon-vikinglotto_logo_blue',
      };

      if (!mapping[game]) return null;

      return '/Components/DanskeSpil/Domain/NumberGamePackage/Graphics/SpriteSheets/PackageCommonIcons.svg#' + mapping[game];
    };

    var mapGameTypeIcon = function (gameType) {
      gameType = gameType?.toLowerCase();

      var mapping = {
        jackpot: 'icon-jackpot_logo_bg_yellow',
        playtogethersubscription: 'icon-playtogether-subscription_logo_bg_green'
      };

      if (!mapping[gameType]) return null;

      return '/Components/DanskeSpil/Domain/NumberGamePackage/Graphics/SpriteSheets/PackageCommonIcons.svg#' + mapping[gameType];
    };



    var leadingZero = function (val) {
      if (val >= 10) return val;

      return '0' + val;
    };

    var isSameDay = function (date1, date2) {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };

    const isValidHexCode = (string) => {
      return /^#[0-9A-F]{6}$/i.test(string);
    };

    const hexToHSL = (hex) => {
      // Convert hex to RGB
      let r = parseInt(hex.substring(1, 3), 16) / 255;
      let g = parseInt(hex.substring(3, 5), 16) / 255;
      let b = parseInt(hex.substring(5, 7), 16) / 255;

      // Find the min and max values of RGB
      let cmin = Math.min(r, g, b);
      let cmax = Math.max(r, g, b);
      let delta = cmax - cmin;

      // Calculate HSL values
      let h = 0;
      let s = 0;
      let l = (cmax + cmin) / 2;

      if (delta !== 0) {
        switch (cmax) {
        case r:
          h = ((g - b) / delta) % 6;
          break;
        case g:
          h = ((b - r) / delta) + 2;
          break;
        case b:
          h = ((r - g) / delta) + 4;
          break;
        }
        h = Math.round(h * 60);
        s = Math.round(delta / (1 - Math.abs((2 * l) - 1)) * 100);
      }

      l = Math.round(l * 100);

      return [h, s, l];
    };

    const setCssHslVariables = ({ hexColor, variableName, rootElement }) => {
      if (!isValidHexCode(hexColor)) {
        return;
      }

      const hslLabels = ['h', 's', 'l'];
      const hslValues = hexToHSL(hexColor);
      const _rootElement = rootElement || document.documentElement;
      const _variableName = variableName || 'club-theme';

      hslValues.forEach((value, index) => {
        _rootElement.style.setProperty(`--${_variableName}-color-${hslLabels[index]}`, value);
      });
    };

    var getThemeProperty = function (property, id, themes) {
      var themesKey = property || null;
      switch (property) {
      case 'colorThemes':
        themesKey = 'colorThemes';
        break;
      }

      if (!property || !id || !themes || !themesKey) return;

      return themes[themesKey].filter(function (themeProperty) {
        return themeProperty.id === id;
      })[0];
    };

    var checkLoginStatus = function (callback) {
      LoginController.getLoginStatus(function (isLoggedIn) {
        if (!isLoggedIn) {
          var homeUrl = location.pathname.split('/', 2).join('/'); // would be: /spil-sammen
          LoginController.openLogin({
            cancelUrl: homeUrl
          });
        }
        if (callback) callback(true);
      });
    };

    // Public functions:
    return {
      formatCurrency: Utils.formatCurrency,
      isMobile: Utils.isMobile,
      openLogin: LoginController.openLogin,
      getLoginStatus: LoginController.getLoginStatus,
      getQueryParam: Utils.getQueryParam,
      shortenPlayerName: shortenPlayerName,
      getWeekNumber: getWeekNumber,
      formatDrawWeeks: formatDrawWeeks,
      countTotalRows: countTotalRows,
      gameTypeMapping: gameTypeMapping,
      redirectOnLogout: redirectOnLogout,
      leadingZero: leadingZero,
      isSameDay: isSameDay,
      triggerBalanceUpdate: triggerBalanceUpdate,
      mapGameToDictionary: mapGameToDictionary,
      parseISO8601: Utils.parseISO8601,
      getLongDate: Utils.getLongDate,
      getLongDKDateByDate: Utils.getLongDKDateByDate,
      mapGameIcon: mapGameIcon,
      mapGameTypeIcon: mapGameTypeIcon,
      isValidHexCode,
      hexToHSL,
      setCssHslVariables,
      getThemeProperty: getThemeProperty,
      checkLoginStatus: checkLoginStatus
    };

  });
